import store, { useCurShop, usePlat, useToken } from './store'

const fn = async (headers:any) => {
  try {
    const res = await fetch('http://localhost:10000/api/auth', { headers })
    const o = await res.json()
    console.log(o)
    if (o.data.clearToken) {
      console.log('clear token from api/auth')
      store.dispatch('route/changeToken', null)
      store.commit('route/curShop', null)
    }
  } catch (err) {
    console.error('api/auth happen wrong')
    store.dispatch('route/changeToken', null)
    store.commit('route/curShop', null)
  }
}

export default async () => {
  if (process.env.NODE_ENV === 'development') {
    const token = useToken()
    const shopId = useCurShop()
    const bizSource = usePlat()
    console.log(`post token ${token} shopId ${shopId} bizSource ${bizSource}`)
    await fn({ token, shopId, bizSource })
  }
}
